const ITEMS = [
    "14 dagen gratis proef",
    "Scenario's in minuten",
    "AI-powered",
    "P10–P90 kansberekening",
    "Monte Carlo simulator",
    "Nederlandse standaarden",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="text-sm uppercase tracking-[0.25em] font-bold text-white px-8 whitespace-nowrap">
                    {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-white/50" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative bg-[#FF6B00] border-y border-white/10 py-5 overflow-hidden"
    >
        <div className="flex w-max animate-marquee">
            <Row />
            <Row />
        </div>
    </div>
);

export default Marquee;
